import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import clientData from 'utils/client-data'
import { css } from 'glamor'
import {
  HeadingText,
  BodyText,
  CaptionText,
  Divider,
  Button,
  IconButton,
  V2ChatIcon,
  V2ShareIosIcon,
  V2ShippingSendIcon,
  v2grey600,
} from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
import ProductCoverPhoto from '../shared/components/product-cover-photo'
import { getFormattedAmount } from '../../shared/amount-utils'

import { phoneLandscapeMaxAndSmaller } from 'lib/styles/media-queries'

const l10n = getContent('pages/shops/product-detail')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const ContentBlock = glamorous.div({
  width: '100%',
  marginTop: '20px',
  [phoneLandscapeMaxAndSmaller]: {
    width: '100%',
  },
})

const ProductTitle = css({
  marginBottom: '5px',
  overflowWrap: 'break-word',
})

const ProductDescription = css({
  marginBottom: '24px',
})

const DividerCss = css({
  margin: '24px 0',
})

const ShippingFee = glamorous.div({
  marginTop: '24px',
  color: v2grey600,
  display: 'flex',
  alignItems: 'center',
})

const ShopActions = glamorous.div({
  marginTop: '36px',
  display: 'flex',
  justifyContent: 'space-around',
})

const ProductActions = glamorous.div({
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
})

const shopActionButton = {
  width: '100%',
  height: '48px',
  padding: 0,
  margin: '0 16px',
}

const customMarginLeft = {
  marginLeft: '8px',
}

const customMarginRight = {
  marginRight: '8px',
}

const productActionButton = css({
  margin: '0 8px',
})

ProductDetail.propTypes = {
  productDetails: PropTypes.object.isRequired,
  shopHandle: PropTypes.string.isRequired,
  isUserLoggedIn: PropTypes.bool,
}

ProductDetail.defaultProps = {
  productDetails: {
    productId: 'someString',
    productTitle: 'Copper & Turquoise Teardrop Earrings',
    productPrice: 21.0,
    shippingFee: '3.50',
    currencyCode: 'USD',
    availableItems: 12,
    productDetailText: `✨ Handmade item
      ✨ Length: 2.5 CM; Width: 1.5 CM
      ✨ Materials: Rose gold
      ✨ Gemstone: Turquoise
      ✨ Closure: Ear wire
      ✨ Style: Boho & hippie
      ✨ Recycled

      Casual geometric teardrop statement earrings made of purple-heart, reclaimed mahogany, padauk, black gabon ebony, paela, and holly. Inlaid with Kingman turquoise and recycled copper, finished with delicate 14k rose gold ear wires.
      
      Very lightweight eye-catching earrings.`,
  },
  shopHandle: 'orangemoon',
  isUserLoggedIn: clientData.isUserLoggedIn,
}

function ProductDetail(props) {
  const advanceToPayWithPaypalFlow = e => {
    e.preventDefault()
    // props.history.push(`TODO: pay with paypal flow URL`)
  }

  const advanceToGuestPayFlow = e => {
    e.preventDefault()
    // props.history.push(`TODO: pay as a guest flow URL`)
  }

  const handleChat = () => {}
  const handleShare = () => {}

  const shippingFeePrice = getFormattedAmount({
    amount: props.productDetails.shippingFee.toString(),
    currencyCode: props.productDetails.currencyCode,
    symbolIsoCurrency: true,
  })

  return (
    <Container data-test-id="shops-product-detail">
      <ProductCoverPhoto
        data-test-id="shops-product-photos-container"
        allowEdit={false}
      />
      <ContentBlock>
        <HeadingText size="sm" className={`${ProductTitle}`}>
          {props.productDetails.productTitle}
        </HeadingText>
        <Divider theme="v2" className={`${DividerCss}`} />
        <ShippingFee>
          <V2ShippingSendIcon size="xs" />
          <CaptionText style={{ marginLeft: '6px', color: v2grey600 }}>
            {l10n('shippingFee', { shippingFeePrice })}
          </CaptionText>
        </ShippingFee>

        <ShopActions>
          <Button
            theme="v2"
            className={`${
              !props.isUserLoggedIn
                ? css(shopActionButton, customMarginRight)
                : css(shopActionButton)
            }`}
            onClick={advanceToPayWithPaypalFlow}
            data-test-id="shops-product-pay-with-paypal"
            branded
          >
            {l10n('button.payWithPayPal')}
          </Button>
          {!props.isUserLoggedIn && (
            <Button
              theme="v2"
              className={`${css(shopActionButton, customMarginLeft)}`}
              onClick={advanceToGuestPayFlow}
              data-test-id="shops-product-pay-as-guest"
            >
              {l10n('button.payAsAGuest')}
            </Button>
          )}
        </ShopActions>

        <ProductActions>
          <IconButton
            theme="v2"
            svgIconComponent={V2ChatIcon}
            onClick={handleChat}
            buttonType="secondary"
            className={`${productActionButton}`}
          >
            {l10n('icon.chat')}
          </IconButton>
          <IconButton
            theme="v2"
            svgIconComponent={V2ShareIosIcon}
            onClick={handleShare}
            buttonType="secondary"
            className={`${productActionButton}`}
          >
            {l10n('icon.share')}
          </IconButton>
        </ProductActions>
        <Divider theme="v2" className={`${DividerCss}`} />
        <BodyText className={`${ProductDescription}`} strong>
          {l10n('productDetails')}
        </BodyText>
        <BodyText style={{ whiteSpace: 'pre-line' }}>
          {props.productDetails.productDetailText}
        </BodyText>
      </ContentBlock>
    </Container>
  )
}
export default ProductDetail
